import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import ClassicTitledTile from "./ClassicTitledTile.jsx";
import UserListEditor from "./UserListEditor.jsx";
import TagListEditor from "../component/TagListEditor";
import StatusListEditor from "../component/StatusListEditor";
import ApiService from "../../../Services/ApiService";
import UserService from "../../../Services/UserService";
import AuthorizeService from "../../../ApiAuthorization/AuthorizeService.js";
import Markdown from "./Markdown";
import Spinner from "../../../PageLayout/Spinner";
import DevOpsFileLink from "./DevOpsFileLink";
import Ellipsis from "clamp-js";
import AppConfig from "../../../Configuration/AppConfig";
import ProjectUserPref from "./ProjectUserPref";
import ProjectService from "../../../Services/ProjectService";
import blankProjectImg from "images/blank_project_image.png";
import padLockRed from "images/padlock_red_icone.svg";
import padLockGreen from "images/padlock_green_icone.svg";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {RocketIcon,BrowserIcon, LockIcon, SyncIcon } from "@primer/octicons-react";
import moment from "moment";

class ProjectBasicDescription extends Component {
  static propTypes = {
    project: PropTypes.any.isRequired,
    projectMarkdownDescription: PropTypes.any,
    availableTags: PropTypes.array.isRequired,
    availableRoles: PropTypes.array.isRequired,
    isUserDataScientist: PropTypes.bool.isRequired,
    isDevOpsUser: PropTypes.bool.isRequired,
    headerSection: PropTypes.any,
  };

  constructor(props) {
    super(props);
    const env = AppConfig.Environment.IsProd ? "" : "-hml";
    const webappUrl =
      "http://aks-codai" + env + ".one4u.services/" + props.project.shortName + "/app/";

    const documentationUrl =
      "http://aks-codai" + env + ".one4u.services/" + props.project.shortName + "/doc/";
    const currentUser = AuthorizeService.getUser();
    this.prodSwitch = React.createRef();

    const availableTagsStatus = props.availableTags.filter(
      (f) => f.tagTypeRefId === "status"
    );
    const availableTagsStatusId = availableTagsStatus.map((f) => f.tagRefId);

    const projectStatus = props.project.projectTags.filter((value) =>
      availableTagsStatusId.includes(value.tagId)
    );

    const projectNotStatus = props.project.projectTags.filter(
      (value) => !availableTagsStatusId.includes(value.tagId)
    );

    const projectStatusSelected = projectStatus.map((f) => ({
      tagId: f.tagId,
      tag: undefined,
    }));
    const projectNotStatusSelected = projectNotStatus.map((f) => ({
      tagId: f.tagId,
      tag: undefined,
    }));
    const currentProjectProd = props.project.projectTags.find(
      (f) => f.tagId === "prod"
    );
    const currentProjectProdCreatedAt =
      currentProjectProd && currentProjectProd.createdAt
        ? moment(currentProjectProd.createdAt).format("DD/MM/YYYY")
        : "";

    this.state = {
      project: props.project,
      projectImage: blankProjectImg,
      isOwner:
        props.project.projectUsers.findIndex(
          (user) =>
            user.profileTypeRefId === "ADMIN" &&
            user.user.upn === currentUser.preferred_username
        ) !== -1,
      isMember: props.project.projectUsers
        .findIndex(user => user.user.upn === currentUser.preferred_username) !== -1,
      confirmTagSave: false,
      isEditingTag: false,
      confirmStatusSave: false,
      isEditingStatus: false,
      selectedTags: projectNotStatusSelected,
      selectedStatus: projectStatusSelected,
      currentProdDate: currentProjectProdCreatedAt,
      confirmVideoUrlSave: false,
      isEditingVideoUrl: false,
      confirmTeamsUrlSave: false,
      isEditingTeamsUrl: false,
      confirmUserSave: false,
      isSavingUser: false,
      isEditingUser: false,
      isEditingTitle: false,
      isAccessRestrict: false,
      confirmTitleSave: false,
      isEditingEnableWebAppProject: false,
      isEditingEnableDocumentationProject: false,
      isEditingRestrictAccessProject: false,
      confirmEnableWebAppProjectSave: false,
      confirmEnableDocumentationProjectSave: false,
      confirmRestrictAccessProjectSave: false,
      webappUrl,
      documentationUrl,
      disableJoinTeamButton: false,
      isRebootingWebAppAndDoc: false
    };

  }

  componentDidMount() {
    ProjectService.getProjectImage(this.props.project.projectId)
      .then((imageUrl) => {
        this.setState({ projectImage: imageUrl });
      })
      .catch((error) => clearTimeout(error.errorDisplayTimer));
  }

  updateProjectTitle = (title) => {
    this.setState({ project: { ...this.state.project, name: title } });
  };

  updateVideoUrl = (title) => {
    this.setState({ project: { ...this.state.project, videoUrl: title } });
  };

  updateTeamsUrl = (title) => {
    this.setState({ project: { ...this.state.project, teamsUrl: title } });
  };

  updatePublicProject = (title) => {
    this.setState({ project: { ...this.state.project, isPublic: title } });
  };

  updateWebAppProject = (title) => {
    this.setState({ project: { ...this.state.project, enableWebApp: title } });
  };
 updateDocumentationProject = (title) => {
    this.setState({ project: { ...this.state.project, enableDocumentation: title } });
  };
  updaterestrictAccessWebAppStatus = (title) => {
    this.setState({ project: { ...this.state.project, restrictAccessWebApp: title } });
  };
  updaterestrictAccessDocumentationStatus = (title) => {
    this.setState({ project: { ...this.state.project, restrictAccessDocumentation: title } });
  };

  editTitleClick = () => {
    this.setState({ isEditingTitle: true });
  };

  editVideoUrlClick = () => {
    this.setState({ isEditingVideoUrl: true });
  };

  editTeamsUrlClick = () => {
    this.setState({ isEditingTeamsUrl: true });
  };


  editPublicProjectClick = () => {
    this.setState({ isEditingPublicProject: true });
  };

  editEnableWebAppStateProjectClick = () => {
    this.setState({ isEditingEnableWebAppProject: true });
  };
  editEnableDocumentationStateProjectClick = () => {
    this.setState({ isEditingEnableDocumentationProject: true });
  };
  editRestrictAccessStateProjectClick = () => {
    this.setState({ isEditingRestrictAccessProject: true });
  };

  saveTitleClick = () => {
    this.setState({ isEditingTitle: false });
    ApiService.updateProject(this.state.project).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmTitleSave: true,
      });
      setTimeout(() => this.setState({ confirmTitleSave: false }), 3000);
    });
  };

  saveVideoUrlClick = () => {
    this.setState({ isEditingVideoUrl: false });
    ApiService.updateProject(this.state.project).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmVideoUrlSave: true,
      });
      setTimeout(() => this.setState({ confirmVideoUrlSave: false }), 3000);
    });
  };

  saveTeamsUrlClick = () => {
    this.setState({ isEditingTeamsUrl: false });
    ApiService.updateProject(this.state.project).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmTeamsUrlSave: true,
      });
      setTimeout(() => this.setState({ confirmTeamsUrlSave: false }), 3000);
    });
  };

  savePublicProjectClick = () => {
    this.setState({ isEditingPublicProject: false });
    ApiService.updateProject(this.state.project).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmPublicProjectSave: true,
      });
      setTimeout(
        () => this.setState({ confirmPublicProjectSave: false }),
        3000
      );
    });
  };

  saveEnableWebAppProjectDataClick = () => {
    this.setState({ isEditingEnableWebAppProject: false });
    ApiService.updateProject(this.state.project).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmEnableWebAppProjectSave: true,
      });
      setTimeout(
        () => this.setState({ confirmEnableWebAppProjectSave: false }),
        3000
      );
    });
  };

  saveEnableDocumentationProjectDataClick = () => {
    this.setState({ isEditingEnableDocumentationProject: false });
    ApiService.updateProject(this.state.project).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmEnableDocumentationProjectSave: true,
      });
      setTimeout(
        () => this.setState({ confirmEnableDocumentationProjectSave: false }),
        3000
      );
    });
  };

  editTagClick = () => {
    this.setState({ isEditingTag: true });
    this.tagsListEditorRef.enablePreviewEdit();
  };

  saveTagClick = () => {
    this.tagsListEditorRef.disablePreviewEdit();
  };

  saveTagChange = (selectedTags) => {
    const newProject = {
      ...this.state.project,
      projectTags: selectedTags.concat(this.state.selectedStatus),
    };

    this.setState({
      project: newProject,
      isEditingTag: false,
      selectedTags: selectedTags,
    });

    ApiService.updateProject(newProject).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmTagSave: true,
      });
      setTimeout(() => this.setState({ confirmTagSave: false }), 3000);
    });
  };

  editStatusClick = () => {
    this.setState({ isEditingStatus: true });
    this.statusListEditorRef.enablePreviewEdit();
    // this.refs.check_me.disabled = this.state.isEditingStatus;
    this.prodSwitch.current.disabled = this.state.isEditingStatus;
  };

  saveStatusClick = () => {
    this.statusListEditorRef.disablePreviewEdit();
  };

  saveStatusChange = (selectedStatus) => {
    if (this.prodSwitch.current.checked) {
      selectedStatus = selectedStatus.concat({ tagId: "prod", tag: undefined });
    }

    const newProject = {
      ...this.state.project,
      projectTags: selectedStatus.concat(this.state.selectedTags),
    };

    this.setState({
      project: newProject,
      isEditingStatus: false,
      selectedStatus: selectedStatus,
    });

    ApiService.updateProject(newProject).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmStatusSave: true,
      });
      setTimeout(() => this.setState({ confirmStatusSave: false }), 3000);
    });
  };

  editWebAppClick = () => {
    this.setState({ isEditingWebApp: true });
  };

  saveProjectChanges = () => {
    const newProject = {
      ...this.state.project,
    };

    this.setState({
      project: newProject,
      isEditingWebApp: false,
    });

    ApiService.updateProject(newProject).then((newSaveProject) => {
      this.setState({
        project: {
          ...this.state.project,
          ...newSaveProject,
        },
        confirmWebAppSave: true,
      });
      setTimeout(() => this.setState({ }), 3000);
    });
  };

  editUserClick = () => {
    this.setState({ isEditingUser: true });
    this.usersListEditorRef.enablePreviewEdit();
  };

  saveUserClick = () => {
    this.usersListEditorRef.disablePreviewEdit();
  };

  joinTeam = async () => {
    const currentUser = AuthorizeService.getUser();
    const usersSearh = await UserService.searchUser(
      currentUser.preferred_username
    ).then((users) => {
      return users.map((user) => ({
        firstName: user.firstName ? user.firstName : "Unknown",
        lastName: user.lastName ? user.lastName : "Unknown",
        upn: user.userPrincipalName,
        key: user.objectId,
        value: user.mail,
        photo: user.photoDataUrl,
      }));
    });
    const u = usersSearh[0];
    const finalUser = [
      {
        profileTypeRefId: "CONTRIB",
        user: {
          upn: u.upn,
          firstName: u.firstName,
          lastName: u.lastName,
          mail: u.value,
          photoUrl: u.photo,
        },
      },
    ];

    const newUserList = [...this.state.project.projectUsers, ...finalUser];
    this.setState({
      disableJoinTeamButton : true
    });
    this.saveUserChange(newUserList);
  };

  saveUserChange = (selectedUsers) => {
    const newProject = {
      ...this.state.project,
      projectUsers: selectedUsers,
    };

    this.setState({
      project: newProject,
      isEditingUser: false,
      isSavingUser: true,
    });

    ApiService.updateProject(newProject).then((newSaveProject) => {
      this.setState({
        project: newSaveProject,
        isSavingUser: false,
        confirmUserSave: true,
      });
      setTimeout(() => this.setState({ confirmUserSave: false }), 2000);
    });
  };

  rebootWebAppAndDoc = () => {
      this.setState({
        isRebootingWebAppAndDoc: true,
      });
      ApiService.rebootWebAppAndDoc(this.state.project).then().finally(() => {
        setTimeout(() => this.setState({ isRebootingWebAppAndDoc: false }), 60000 );
      });
    };
  
  switchProdChange = (e) => {
    const onProd = e.target.checked;
    const currentProdDate = onProd ? moment().format("DD/MM/YYYY") : "";
    this.setState({ currentProdDate });
  };

  render = () => {
    const availableTagsStatus = this.props.availableTags.filter(
      (f) => f.tagTypeRefId === "status" && f.tagRefId !== "prod"
    );
    const availableTagsNotStatus = this.props.availableTags.filter(
      (f) => f.tagTypeRefId !== "status"
    );
    const availableTagsStatusId = availableTagsStatus.map((f) => f.tagRefId);
    const projectSelectedTags = this.state.project.projectTags.filter(
      (value) =>
        !availableTagsStatusId.includes(value.tagId) && value.tagId !== "prod"
    );

    const projectSelectedStatus = this.state.project.projectTags.filter(
      (value) => availableTagsStatusId.includes(value.tagId)
    );

    const onProd = this.state.project.projectTags.some(
      (f) => f.tagId === "prod"
    );

    const disableJoinTeam = this.state.project.projectMemberRequest.length !== 0 || this.state.disableJoinTeamButton;

    return [
      <div className="ProjectDescriptionHeader" key={1}>
        <Container>
          <Row>
            <Col className="projectImageContainer">
              <img
                className="projectImage"
                alt="project"
                src={this.state.projectImage}
              />
              {this.props.isDevOpsUser && (
                <DevOpsFileLink
                  project={this.props.project}
                  devOpsPath={ProjectService.devOpsPathProjectImage}
                />
              )}
            </Col>
            <Col className="projectTitle" sm={true}>
              {!(
                (this.state.isOwner || this.props.isUserAdmin) &&
                this.state.isEditingTitle
              ) ? (
                <h3
                  ref={(r) => {
                    r && Ellipsis(r, { clamp: 2 });
                  }}
                >
                  {this.state.project.name}
                </h3>
              ) : (
                <Form.Control
                  required
                  className="projectNameEditionInput"
                  placeholder="Enter the project name"
                  aria-label="Project name"
                  value={this.state.project.name}
                  onChange={(i) => this.updateProjectTitle(i.target.value)}
                />
              )}
              <ProjectUserPref
                projectId={this.props.project.projectId}
              ></ProjectUserPref>
              {(this.state.isOwner || this.props.isUserAdmin) &&
                (this.state.isEditingTitle ? (
                  <span
                    className="projectDescriptionSaveBtn"
                    onClick={this.saveTitleClick}
                  >
                    <span className="routerLink">
                      <i className="icon-cloud-upload" />
                      <b>{" SAVE"}</b>
                    </span>
                  </span>
                ) : (
                  <i
                    className={
                      "projectNameEditIcon " +
                      (this.state.confirmTitleSave
                        ? "icon-circle-checked"
                        : "icon-pencil-edit")
                    }
                    onClick={this.editTitleClick}
                    title="Modify section"
                  />
                ))}
            </Col>
            {this.props.headerSection}
          </Row>
        </Container>
      </div>,
      <div className="projectBasicDescription" key={2}>
        {this.state.project.isPublic && !(this.state.isOwner || this.state.isMember) && !this.props.isDetailPage  ?
          (<Button onClick={this.joinTeam} disabled={disableJoinTeam} variant="success" style={{ backgroundColor: '#030F40', float: 'right', color: 'white' }}> {!disableJoinTeam ?"Join project team" : "Adding to the team in progress ..."}</Button>)
          : null
        }
        <Container className="descriptionSubContainer">
            {this.state.project.projectMemberRequest && this.state.project.projectMemberRequest.length > 0 ? (<Row>
              <Button disabled style={({ marginLeft: 'auto' })} className="infoButton">Member request in progress, please refresh in a few minutes</Button>
              </Row>) : null
              }
          <Row>
            <Col sm={true}>
              <Container>
                <Row>
                  <Col sm={true}>
                    <ClassicTitledTile
                      title={
                        <h6>
                          DESCRIPTION{" "}
                          <span className="edit-section">
                            {this.props.isDevOpsUser &&
                              this.props.projectMarkdownDescription && (
                                <DevOpsFileLink
                                  project={this.props.project}
                                  devOpsPath={
                                    this.props.projectMarkdownDescription
                                      .relPath
                                  }
                                />
                              )}
                          </span>
                        </h6>
                      }
                    >
                      {this.props.project.private &&
                        !this.props.isDevOpsUser ? (
                        <span className="confidentialImg">Confidential</span>
                      ) : this.props.projectMarkdownDescription &&
                        this.props.projectMarkdownDescription.content.length ? (
                        <Markdown
                          projectId={this.state.project.projectId}
                          path={this.props.projectMarkdownDescription.relPath}
                        >
                          {this.props.projectMarkdownDescription.content}
                        </Markdown>
                      ) : (
                        this.props.project.description
                      )}
                    </ClassicTitledTile>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <ClassicTitledTile title={<h6>COST CENTER</h6>}>
                      {
                        this.props.project.costcenterRef
                          .costcenterRefDescription
                      }
                    </ClassicTitledTile>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <ClassicTitledTile title={<h6>CONFIDENTIAL</h6>}>
                      {this.props.project.private ? (
                        <span>
                          <img
                            className="confidentialityIcon"
                            alt="lock"
                            src={padLockRed}
                          />
                          {"Yes"}
                        </span>
                      ) : (
                        <span>
                          <img
                            className="confidentialityIcon"
                            alt="unlock"
                            src={padLockGreen}
                          />
                          {"No"}
                        </span>
                      )}
                    </ClassicTitledTile>
                  </Col>
                  {(this.state.isOwner || this.props.isUserAdmin) &&
                    this.props.isDetailPage && !this.props.project.private ? (
                    <Col sm={6}>
                      <ClassicTitledTile
                        title={
                          <h6>
                            Public Project{" "}
                            <span className="edit-section">
                              {(this.state.isOwner || this.props.isUserAdmin) && !this.state.isEditingUser &&
                                (this.state.isEditingPublicProject ? (
                                  <span
                                    className="projectDescriptionSaveBtn"
                                    onClick={this.savePublicProjectClick}
                                  >
                                    <span className="routerlink">
                                      <i className="icon-cloud-upload" />
                                      {" save"}
                                    </span>
                                  </span>
                                ) : (
                                  <i
                                    className={
                                      this.state.confirmPublicProjectSave
                                        ? "icon-circle-checked"
                                        : "icon-pencil-edit"
                                    }
                                    onClick={this.editPublicProjectClick}
                                    title="Modify section"
                                  />
                                ))}
                            </span>
                          </h6>
                        }
                      >
                        {!this.state.isEditingPublicProject ? (
                          this.state.project.isPublic ? (
                            <span>
                              <img
                                className="confidentialityIcon"
                                alt="unlock"
                                src={padLockGreen}
                              />
                              {"Yes"}
                            </span>
                          ) : (
                            <span>
                              <img
                                className="confidentialityIcon"
                                alt="lock"
                                src={padLockRed}
                              />
                              {"No"}
                            </span>
                          )
                        ) : (
                          <Form.Check
                            type="switch"
                            id="custom-switch1"
                            disabled={false}
                            checked={
                              this.state.project.isPublic ? "checked" : ""
                            }
                            onChange={() =>
                              this.updatePublicProject(
                                !this.state.project.isPublic
                              )
                            }
                            label=""
                          />
                        )}
                      </ClassicTitledTile>
                    </Col>
                  ) : null}
                </Row>

              </Container>
            </Col>
            <Col sm={7} className="details-section">
              <Container>
                <Row>
                  <Col style={{ maxWidth: "50%" }}>
                    <Row>
                      <ClassicTitledTile
                        title={
                          <h6>
                            TAGS{" "}
                            <span className="edit-section">
                              {(this.state.isOwner || this.props.isUserAdmin) && !this.state.isEditingUser &&
                                (this.state.isEditingTag ? (
                                  <span
                                    className="projectDescriptionSaveBtn"
                                    onClick={this.saveTagClick}
                                  >
                                    <span className="routerlink">
                                      <i className="icon-cloud-upload" />
                                      {" save"}
                                    </span>
                                  </span>
                                ) : (
                                  <i
                                    className={
                                      this.state.confirmTagSave
                                        ? "icon-circle-checked"
                                        : "icon-pencil-edit"
                                    }
                                    onClick={this.editTagClick}
                                    title="Modify section"
                                  />
                                ))}
                            </span>
                          </h6>
                        }
                      >
                        <TagListEditor
                          ref={(e) => (this.tagsListEditorRef = e)}
                          defaultValue={projectSelectedTags}
                          availableTags={availableTagsNotStatus}
                          onPreviewEditEnd={this.saveTagChange}
                          preview={true}
                          disable={
                            !this.state.isOwner && !this.props.isUserAdmin
                          }
                        />
                      </ClassicTitledTile>
                    </Row>
                   
                    <Row>
                      <ClassicTitledTile
                        title={
                          <h6>
                            STATUS{" "}
                            <span className="subtitle">
                              - Tags' modification date
                            </span>
                            <span className="edit-section">
                              {(this.state.isOwner || this.props.isUserAdmin) && !this.state.isEditingUser &&
                                (this.state.isEditingStatus ? (
                                  <span
                                    className="projectDescriptionSaveBtn"
                                    onClick={this.saveStatusClick}
                                  >
                                    <span className="routerlink">
                                      <i className="icon-cloud-upload" />
                                      {" save"}
                                    </span>
                                  </span>
                                ) : (
                                  <i
                                    className={
                                      this.state.confirmStatusSave
                                        ? "icon-circle-checked"
                                        : "icon-pencil-edit"
                                    }
                                    onClick={this.editStatusClick}
                                    title="Modify section"
                                  />
                                ))}
                            </span>
                          </h6>
                        }
                      >
                        <StatusListEditor
                          ref={(e) => (this.statusListEditorRef = e)}
                          defaultValue={projectSelectedStatus}
                          availableTags={availableTagsStatus}
                          onPreviewEditEnd={this.saveStatusChange}
                          preview={true}
                          disable={
                            !this.state.isOwner && !this.props.isUserAdmin
                          }
                        />
                      </ClassicTitledTile>
                    </Row>
                    <Row>
                      <Form.Check
                        type="switch"
                        ref={this.prodSwitch}
                        id="custom-switch"
                        label={
                          <span className="tagLabel">
                            <a
                              href={"/project/search?textSearch=&tagId=prod"}
                              alt={"Production"}
                              title={"search for this tag"}
                            >
                              <span>
                                <RocketIcon size={22} />
                              </span>
                              Production
                            </a>
                            <span>
                              {this.state.currentProdDate
                                ? "- " + this.state.currentProdDate
                                : ""}
                            </span>
                          </span>
                        }
                        onChange={this.switchProdChange}
                        defaultChecked={onProd}
                        disabled={!this.state.isEditingStatus}
                        title="Switch on/off&#13;the production status"
                      />
                    </Row>
                  </Col>
                  <Col style={{ maxWidth: "60%" }}>
                    <ClassicTitledTile
                      title={
                        <h6 aria-label="search" title="There are three main roles in a project:&#13;
                          - Product owner who have read-only access to code.&#13;
                          - Contributors who have full access to DevOps code and AML workspace.&#13;
                          - Administrator who is a special contributor who can also modify members&#13;   and archive the project."
                          >
                          TEAM MEMBERS{" "}
                          <span className="edit-section">
                            {(this.state.isOwner || this.props.isUserAdmin) &&
                              this.state.project.projectMemberRequest.length ===
                              0 &&
                              (this.state.isEditingUser ? (
                                <span
                                  className="projectDescriptionSaveBtn"
                                  onClick={this.saveUserClick}
                                >
                                  <span className="routerlink">
                                    <i className="icon-cloud-upload" />
                                    {" save"}
                                  </span>
                                </span>
                              ) : this.state.isSavingUser ? (
                                <Spinner />
                              ) : (
                                !this.state.confirmUserSave && (
                                  <i
                                    className="icon-pencil-edit"
                                    onClick={this.editUserClick}
                                    title="Modify section"
                                  />
                                )
                              ))}
                            {(this.state.isOwner || this.props.isUserAdmin) &&
                              !this.state.isEditingUser &&
                              this.state.confirmUserSave ? (
                              <i className="icon-circle-checked" />
                            ) : null}
                          </span>
                        </h6>
                      }
                    >
                      <UserListEditor
                        ref={(e) => (this.usersListEditorRef = e)}
                        value={this.state.project.projectUsers}
                        memberRequest={this.state.project.projectMemberRequest}
                        availableRoles={this.props.availableRoles}
                        onPreviewEditEnd={this.saveUserChange}
                        preview={true}
                        disable={
                          (!this.state.isOwner && !this.props.isUserAdmin) ||
                          this.state.project.projectMemberRequest.length > 0
                        }
                      />
                    </ClassicTitledTile>
                  </Col>
                </Row>

                <Row>
                  {(this.state.isOwner || this.props.isUserAdmin) &&
                    this.props.isDetailPage ? (
                    <Col sm={12}>
                      <ClassicTitledTile
                        title={
                          <h6>
                            Teams url{" "}
                            <span className="edit-section">
                              {(this.state.isOwner || this.props.isUserAdmin) && !this.state.isEditingUser &&
                                (this.state.isEditingTeamsUrl ? (
                                  <span
                                    className="projectDescriptionSaveBtn"
                                    onClick={this.saveTeamsUrlClick}
                                  >
                                    <span className="routerlink">
                                      <i className="icon-cloud-upload" />
                                      {" save"}
                                    </span>
                                  </span>
                                ) : (
                                  <i
                                    className={
                                      this.state.confirmTeamsUrlSave
                                        ? "icon-circle-checked"
                                        : "icon-pencil-edit"
                                    }
                                    onClick={this.editTeamsUrlClick}
                                    title="Modify section"
                                  />
                                ))}
                            </span>
                          </h6>
                        }
                      >
                        {this.props.project.private &&
                          !this.props.isDevOpsUser ? (
                          <span className="confidentialImg">Confidential</span>
                        ) : !this.state.isEditingTeamsUrl ? (
                          <a href={this.state.project.teamsUrl} target="_blank" rel="noreferrer">
                            {this.state.project.teamsUrl?.substring(0, 80)}
                          </a>
                        ) : (
                          <Form.Control
                            required
                            className="projectNameEditionInput"
                            placeholder="Enter Teams Url"
                            aria-label="Teams Url"
                            value={this.state.project.teamsUrl}
                            onChange={(i) =>
                              this.updateTeamsUrl(i.target.value)
                            }
                          />
                        )}
                      </ClassicTitledTile>
                    </Col>
                  ) : null}
                </Row>

                {(this.state.isOwner || this.props.isUserAdmin)
                    && this.props.isDetailPage ? (
                <Row>
                  {/* Documentation */}
                  <Col style={{ maxWidth: "50%" }}>
                    <Row>
                         <ClassicTitledTile title={<h6>
                            Documentation{" "}
                            <span className="edit-section">
                              {(this.state.isOwner || this.props.isUserAdmin)  && !this.state.isEditingUser && this.props.isDetailPage && !this.state.isEditingEnableWebAppProject && this.state.project.projectMemberRequest.length === 0 &&
                                (this.state.isEditingEnableDocumentationProject ? (
                                  <span
                                    className="projectEnableDocumentationSaveBtn"
                                    onClick={this.saveEnableDocumentationProjectDataClick}
                                  >
                                    <span className="routerlink">
                                      <i className="icon-cloud-upload" />
                                      {" save"}
                                    </span>
                                  </span>
                                ) : (
                                  <i
                                    className={
                                      this.state.confirmEnableDocumentationProjectSave
                                        ? "icon-circle-checked"
                                        : "icon-pencil-edit"
                                    }
                                    onClick={this.editEnableDocumentationStateProjectClick}
                                    title="Modify section"
                                  />
                                ))}
                            </span>
                          </h6>
                        }>
                <Col sm={12}>
                <div className={`formInputTextHelper ${(this.state.project.enableDocumentation) ? "": "d-none"}`}>
                Provides a website to browse the documentation.</div>
                  <OverlayTrigger
                      key="EnableDocumentation"
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-EnableDocumentation`}>
                          The processing of the request requires a technical prerequisite with a set-up time of 48/72h.
                        </Tooltip>
                      }
                    >
                    <Form.Check
                        type="switch"
                        id="custom-switch3"
                        label={
                          <span className="tagLabel">
                              <span>
                                <BrowserIcon size={20} />
                              </span>
                              Enable Documentation
                          </span>
                        }
                        checked={this.state.project.enableDocumentation ? "checked" : ""}
                        onChange={() =>
                              this.updateDocumentationProject(
                                !this.state.project.enableDocumentation
                              )}
                        disabled={!this.state.isEditingEnableDocumentationProject}
                        title="The processing of the request requires a technical prerequisite with a set-up time of 48/72h"
                      />
                    </OverlayTrigger>
                    <div className={`formInputTextHelper ${(this.state.project.restrictAccessDocumentation) ? "": "d-none"}`}>Restrict access to project members only.</div>
                  <Form.Check className={(this.state.project.enableDocumentation) ? "": "d-none"}
                        type="switch"
                        id="custom-switch5"
                        label={
                          <span className="tagLabel">
                              <span>
                                <LockIcon size={20} />
                              </span>
                              Restrict Access
                          </span>
                        }
                        checked={this.state.project.restrictAccessDocumentation ? "checked" : ""}
                        onChange={() => this.updaterestrictAccessDocumentationStatus(!this.state.project.restrictAccessDocumentation)}
                        disabled={!this.state.isEditingEnableDocumentationProject}
                        title="Switch on/off the Restrict Access status"
                      />
                      </Col>
                  </ClassicTitledTile>
                    </Row>

                  </Col>
                 {/* End Documentation */}
                 {/* WebApp */}
                  <Col style={{ maxWidth: "60%" }}>
                     <ClassicTitledTile title={<h6>
                          Web Application {" "}
                            <span className="edit-section">
                              {(this.state.isOwner || this.props.isUserAdmin) && !this.state.isEditingUser && this.props.isDetailPage && !this.state.isEditingEnableDocumentationProject && this.state.project.projectMemberRequest.length === 0 &&
                                (this.state.isEditingEnableWebAppProject ? (
                                  <span
                                    className="projectEnableWebAppSaveBtn"
                                    onClick={this.saveEnableWebAppProjectDataClick}
                                  >
                                    <span className="routerlink">
                                      <i className="icon-cloud-upload" />
                                      {" save"}
                                    </span>
                                  </span>
                                ) : (
                                  <i
                                    className={
                                      this.state.confirmEnableWebAppProjectSave
                                        ? "icon-circle-checked"
                                        : "icon-pencil-edit"
                                    }
                                    onClick={this.editEnableWebAppStateProjectClick}
                                    title="Modify section"
                                  />
                                ))}
                            </span>
                          </h6>
                        }>
                <Col sm={12}>
                <div className={`formInputTextHelper ${(this.state.project.enableWebApp) ? "": "d-none"}`}> Needed for having Rshiny/Streamlit/Flask webapp.</div>
                  <OverlayTrigger
                      key="EnableWebApp"
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-EnableWebApp`}>
                          The processing of the request requires a technical prerequisite with a set-up time of 48/72h.
                        </Tooltip>
                      }
                    >
                    <Form.Check
                        type="switch"
                        id="custom-switch2"
                        label={
                          <span className="tagLabel">
                              <span>
                                <BrowserIcon size={20} />
                              </span>
                              Enable WebApp
                          </span>
                        }
                        checked={this.state.project.enableWebApp ? "checked" : ""}
                        onChange={() =>
                              this.updateWebAppProject(
                                !this.state.project.enableWebApp
                              )}
                        disabled={!this.state.isEditingEnableWebAppProject}
                        title="The processing of the request requires a technical prerequisite with a set-up time of 48/72h"
                      />
                    </OverlayTrigger>
                    <div className={`formInputTextHelper ${(this.state.project.restrictAccessWebApp) ? "": "d-none"}`}>Restrict access to project members only.</div>

                  <Form.Check className={(this.state.project.enableWebApp) ? "": "d-none"}
                        type="switch"
                        id="custom-switch4"
                        label={
                          <span className="tagLabel">
                              <span>
                                <LockIcon size={20} />
                              </span>
                              Restrict Access
                          </span>
                        }
                        checked={this.state.project.restrictAccessWebApp ? "checked" : ""}
                        onChange={() => this.updaterestrictAccessWebAppStatus(!this.state.project.restrictAccessWebApp)}
                        disabled={!this.state.isEditingEnableWebAppProject}
                        title="Switch on/off the Restrict Access status"
                      />
                      </Col>
                  </ClassicTitledTile>
                  </Col>
                   {/* End WebApp */}
                </Row>
                ) : null}
                <Row>
                {this.state.project.enableDocumentation &&
                  ((this.props.isDevOpsUser || this.state.isOwner || this.props.isUserAdmin)
                    || !this.state.project.restrictAccessDocumentation)  ? (
                    <Col style={{ maxWidth: "48%" }}>
                    <Row>
                        <ClassicTitledTile
                          title={
                            <h6>
                              Documentation URL{" "}
                            </h6>
                          }
                        >
                            <a href={this.state.documentationUrl} target="_blank" rel="noreferrer">
                              Documentation - Home
                            </a>
                            <br/>
                        </ClassicTitledTile>
                        </Row>
                    </Col>
                  ) : null}
                  {this.state.project.enableDocumentation &&
                  ((this.props.isDevOpsUser || this.state.isOwner || this.props.isUserAdmin)
                    || !this.state.project.restrictAccessDocumentation)  ? (
                      <Col style={{ maxWidth: "4%" }}></Col>
                  ) : null}
                {this.state.project.enableWebApp &&
                  ((this.props.isDevOpsUser || this.state.isOwner || this.props.isUserAdmin)
                    || !this.state.project.restrictAccessWebApp) ? (
                    <Col style={{ maxWidth: "45%" }}>
                    <Row>
                        <ClassicTitledTile
                          title={
                            <h6>
                              Web Application Url{" "}
                              <span className="edit-section">
                                {(this.state.isOwner ||
                                  this.props.isUserAdmin) &&
                                  !this.state.isEditingWebApp &&
                                  this.state.confirmWebAppSave ? (
                                  <i className="icon-circle-checked" />
                                ) : null}
                              </span>
                            </h6>
                          }
                        >
                            <a href={this.state.webappUrl} target="_blank" rel="noreferrer">
                            Web Application - Home
                            </a>
                            <br/>
                            {this.props.isDetailPage ? (
                              <a href={this.props.project.webAppLogUrl} target="_blank" rel="noreferrer">
                                Web Application - Log
                              </a>
                            ) : null}

                        </ClassicTitledTile>
                        </Row>

                    </Col>
                  ) : null}

                </Row>
                {(this.state.project.enableDocumentation || this.state.project.enableWebApp) && this.props.isDetailPage
                && (this.props.isDevOpsUser || this.state.isOwner || this.props.isUserAdmin) ? (
                  <Row>
                    <Col sm={4}></Col>
                    <Col sm={8}>
                      <Button title={this.state.project.projectMemberRequest.length > 0 ? "Reboot is temporarily disabled due to pending project member request":""} disabled={this.state.isEditingUser || this.state.isRebootingWebAppAndDoc || this.state.confirmUserSave || this.state.isSavingUser  || this.state.project.projectMemberRequest.length > 0 }  onClick={this.rebootWebAppAndDoc} style={({ marginLeft: '65px' })} className="rebootButton">
                      {this.state.isRebootingWebAppAndDoc ? ( <Spinner />) :  ( <SyncIcon />) }{" "}
                      Reboot {(this.state.project.enableDocumentation ? "Documentation" : "" )}
                             {((this.state.project.enableDocumentation && this.state.project.enableWebApp) ? " & ":"")} {this.state.project.enableWebApp
                              ? "Web Application" : ""}
                      </Button>
                    </Col>
                </Row>
                ): null}
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    ];
  };
}

export default ProjectBasicDescription;
